module.exports = __webpack_public_path__ + "img/tooltip_icon.28a40293.png";